import DirectCallLandingView from "../components/landing/directCall/DirectCallLandingView";

const LandingDirectCall4 = () => (
  <DirectCallLandingView
    landingName="landing-direct-call-4"
    phoneDisplay="02 4074 1141"
    phoneTel="tel:+390240741141"
  />
);

export default LandingDirectCall4;
